const UrlService = {
  getQueryString: (attr) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(attr) ? urlParams.get(attr) : null;
  },

  getQueryParamsFromObject: (object) => {
    Object.keys(object).forEach(key => !object[key] && delete object[key])
    return new URLSearchParams(object).toString()
  }
};

export default UrlService;
